import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';

function FAQ() {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleContactClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const faqs = [
    {
      question: 'What is KBros Leather?',
      answer: 'KBros Leather is a family-run business specializing in handcrafted leather goods. We are committed to delivering timeless designs crafted with care and precision. As a two-person team, AJ and Jeremy Keiper bring passion and expertise to every project. We pride ourselves on offering a personal touch to every item, ensuring that each piece reflects our dedication to quality craftsmanship.'
    },
    {
      question: 'Do you offer customization?',
      answer: 'Yes! All of our products can be customized with engravings or unique configurations to suit your preferences. Whether you want a name, logo, or special message, we work with you to create something truly one-of-a-kind. Our advanced engraving techniques ensure precise and elegant results, making your item a cherished keepsake or meaningful gift.'
    },
    {
      question: 'What materials do you use?',
      answer: 'We use premium, eco-tanned leather to ensure durability, sustainability, and a beautiful finish. We work directly with a trusted partner in Italy to source Badalassi Carlo Pueblo leathers, known for their rich texture and vibrant colors. This collaboration allows us to maintain the highest standards of quality while supporting sustainable practices in leather production.'
    },
    {
      question: 'How long does shipping take?',
      answer: 'All of our shipping is handled through USPS unless otherwise requested. Domestic shipping typically takes 3-5 business days. We also offer international shipping, with delivery times varying depending on the destination. Once your order ships, you will receive a tracking number to monitor its progress.'
    },
    {
      question: 'Can I place a bulk or corporate order?',
      answer: (
        <>
          Absolutely! We welcome bulk and corporate orders, whether for employee gifts, client appreciation, or special events. Our team works closely with you to understand your needs and provide personalized options. Discounts may be available for larger orders, so feel free to contact us for details.
          <Box mt={2} textAlign="center">
            <Button onClick={handleContactClick} variant="contained" color="secondary">
              Contact Us for Bulk Pricing
            </Button>
          </Box>
        </>
      )
    },
    {
      question: 'What is your return/exchange policy?',
      answer: 'We want you to love your KBros Leather product. If there are any issues, please contact us within 14 days of delivery to arrange a return or exchange. Customized items may have specific restrictions, but we strive to find a solution that leaves you satisfied. Our goal is to ensure every customer feels valued and confident in their purchase.'
    },
    {
      question: 'What makes KBros Leather products unique?',
      answer: 'Every item we create is handcrafted with attention to detail and designed to last. As a small business, we take pride in offering personalized service and unique designs that stand out. Our use of premium materials and dedication to timeless craftsmanship ensures that each product is as functional as it is beautiful.'
    },
    {
      question: 'How do I care for my leather products?',
      answer: 'Proper care can extend the life and beauty of your leather goods. We recommend using a high-quality leather conditioner periodically to keep the leather supple and hydrated. Avoid prolonged exposure to water and sunlight, and clean spills immediately with a soft, dry cloth. For additional tips, feel free to reach out to us.'
    },
    {
      question: 'Do you offer gift wrapping or packaging?',
      answer: 'Yes, we offer gift wrapping services to make your purchase extra special. Each item is carefully packaged, and you can add a personalized message at checkout. Our gift wrapping ensures your KBros Leather product arrives looking elegant and ready to impress.'
    },
    {
      question: 'Can I visit your workshop?',
      answer: 'Currently, we do not have a public-facing workshop. However, we love sharing insights into our process and behind-the-scenes glimpses of our craftsmanship. Follow us on social media for updates, videos, and stories about how we bring our designs to life.'
    },
    {
      question: 'Do you ship internationally?',
      answer: 'Yes, we are proud to ship our products internationally. Shipping costs and delivery times vary depending on the destination, but we strive to make the process as smooth as possible. Customs duties and taxes may apply and are the responsibility of the buyer. Contact us for any questions about international orders.'
    }
  ];

  return (
    <Box sx={{ padding: 4, maxWidth: 800, margin: 'auto' }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ marginBottom: 4 }}>
        Frequently Asked Questions
      </Typography>
      <Typography
        variant="body1"
        gutterBottom
        align="center"
        sx={{ marginBottom: 4 }}
      >
        If you have a question that isn’t answered here, we’re happy to help!
      </Typography>
      <Box textAlign="center" mb={4}>
        <Button
          onClick={handleContactClick}
          variant="contained"
          color="primary"
          sx={{ textTransform: 'none', padding: '10px 20px', fontSize: '16px', fontWeight: 'bold' }}
        >
          Contact Us
        </Button>
      </Box>
      {faqs.map((faq, index) => (
        <Accordion key={index} sx={{ marginBottom: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      <Modal open={isModalOpen} onClose={handleCloseModal} aria-labelledby="contact-form-title" aria-describedby="contact-form-description">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: 'center',
          pointerEvents: 'none',
        }}>
          <Typography id="contact-form-title" variant="h6" component="h2" gutterBottom>
            Coming Soon!
          </Typography>
          <Typography id="contact-form-description" variant="body2" gutterBottom>
            Our contact form feature is currently under development. Please email us at <a href="mailto:kbrosleather@gmail.com">kbrosleather@gmail.com</a> for any inquiries.
          </Typography>
          <Box mt={2} textAlign="center">
            <Button onClick={handleCloseModal} sx={{ pointerEvents: 'auto', marginTop: 2 }}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FAQ;
